// Language configuration for Mavililer Sözlük
export const LANGUAGES = {
    tr: { name: 'Türkçe', code: 'tr', flag: '🇹🇷' },
    en: { name: 'English', code: 'en', flag: '🇬🇧' },
    ru: { name: 'Русский', code: 'ru', flag: '🇷🇺' },
    az: { name: 'Azərbaycan', code: 'az', flag: '🇦🇿' },
    kk: { name: 'Қазақ', code: 'kk', flag: '🇰🇿' },
    uz: { name: 'Oʻzbek', code: 'uz', flag: '🇺🇿' },
    tk: { name: 'Türkmen', code: 'tk', flag: '🇹🇲' },
    ky: { name: 'Кыргыз', code: 'ky', flag: '🇰🇬' },
} as const

export type LanguageCode = keyof typeof LANGUAGES
export const DEFAULT_LANGUAGE: LanguageCode = 'tr'
